// Generated types for ChangeImpact
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { AttachedRecordReadAPI, AttachedRecordWriteAPI } from '../../shared/types/attachedrecord';
import { RFLPElementReadAPI, RFLPElementWriteAPI } from './rflpelement';
import { AttachedRecordReadAPISchemaObject, AttachedRecordWriteAPISchemaObject } from '../../shared/types/attachedrecord';
import { RFLPElementReadAPISchemaObject, RFLPElementWriteAPISchemaObject } from './rflpelement';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ChangeImpactReadAPI extends RFLPElementReadAPI, AttachedRecordReadAPI {
  /** When this ripple was computed. */
  computed_at?: string;
  /** UUID of the entity whose change this ripple originated from. */
  source_entity_id: string;
  /** Short type name of the source entity (e.g. 'Requirement'). */
  source_entity_type: string;
  /** Count of downstream-impacted entities (excluding source). */
  total?: number;
  /** Traversal cap used for this run. */
  max_depth_used?: number;
  /** JSON-encoded list of impact dicts. Each has {entity_id, type, impact_level, path, severity, effective_owner_id}. */
  impacted_entities_json?: string | null;
  /** JSON-encoded {user_id: [entity_id, ...]} derived grouping — makes per-owner notifications one-shot. */
  by_owner_json?: string | null;
  /** LLM-generated narrative summary — filled by `summarise_impact` after the agent reads the impact list. */
  summary?: string | null;
}

export interface ChangeImpactWriteAPI extends RFLPElementWriteAPI, AttachedRecordWriteAPI {
  /** When this ripple was computed. */
  computed_at?: string;
  /** UUID of the entity whose change this ripple originated from. */
  source_entity_id: string;
  /** Short type name of the source entity (e.g. 'Requirement'). */
  source_entity_type: string;
  /** Count of downstream-impacted entities (excluding source). */
  total?: number;
  /** Traversal cap used for this run. */
  max_depth_used?: number;
  /** JSON-encoded list of impact dicts. Each has {entity_id, type, impact_level, path, severity, effective_owner_id}. */
  impacted_entities_json?: string | null;
  /** JSON-encoded {user_id: [entity_id, ...]} derived grouping — makes per-owner notifications one-shot. */
  by_owner_json?: string | null;
  /** LLM-generated narrative summary — filled by `summarise_impact` after the agent reads the impact list. */
  summary?: string | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ChangeImpactReadAPISchema: z.ZodType<ChangeImpactReadAPI> = RFLPElementReadAPISchemaObject.extend(AttachedRecordReadAPISchemaObject.shape).extend({
  computed_at: z.string().optional(),
  source_entity_id: z.string(),
  source_entity_type: z.string(),
  total: z.number().optional(),
  max_depth_used: z.number().optional(),
  impacted_entities_json: z.string().nullable().optional(),
  by_owner_json: z.string().nullable().optional(),
  summary: z.string().nullable().optional(),
}).passthrough();

export const ChangeImpactWriteAPISchema: z.ZodType<ChangeImpactWriteAPI> = RFLPElementWriteAPISchemaObject.extend(AttachedRecordWriteAPISchemaObject.shape).extend({
  computed_at: z.string().optional(),
  source_entity_id: z.string(),
  source_entity_type: z.string(),
  total: z.number().optional(),
  max_depth_used: z.number().optional(),
  impacted_entities_json: z.string().nullable().optional(),
  by_owner_json: z.string().nullable().optional(),
  summary: z.string().nullable().optional(),
}).passthrough();
